import { render, staticRenderFns } from "./DoraTiles.vue?vue&type=template&id=d7014298&scoped=true"
import script from "./DoraTiles.vue?vue&type=script&lang=js"
export * from "./DoraTiles.vue?vue&type=script&lang=js"
import style0 from "./DoraTiles.vue?vue&type=style&index=0&id=d7014298&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7014298",
  null
  
)

export default component.exports